// Platform metadata for the Promotion Center. Icons via react-icons (brand logos).
import { FaFacebook, FaInstagram, FaLinkedin, FaPinterest, FaXTwitter, FaYoutube, FaEtsy, FaShopify } from "react-icons/fa6";
import { SiWoocommerce } from "react-icons/si";

// Social platforms (from social.* connectors) and marketplaces (ecommerce connectors).
export const SOCIAL_PLATFORMS = [
  { key: "facebook", label: "Facebook", Icon: FaFacebook, color: "#1877F2" },
  { key: "instagram", label: "Instagram", Icon: FaInstagram, color: "#E4405F" },
  { key: "linkedin", label: "LinkedIn", Icon: FaLinkedin, color: "#0A66C2" },
  { key: "x", label: "X", Icon: FaXTwitter, color: "#FFFFFF" },
  { key: "pinterest", label: "Pinterest", Icon: FaPinterest, color: "#BD081C" },
  { key: "youtube", label: "YouTube", Icon: FaYoutube, color: "#FF0000" },
];

export const MARKETPLACES = [
  { key: "etsy", label: "Etsy", Icon: FaEtsy, color: "#F16521" },
  { key: "shopify", label: "Shopify", Icon: FaShopify, color: "#95BF47" },
  { key: "woocommerce", label: "WooCommerce", Icon: SiWoocommerce, color: "#96588A" },
];

export const PLATFORM_BY_KEY = Object.fromEntries(
  [...SOCIAL_PLATFORMS, ...MARKETPLACES].map((p) => [p.key, p]),
);
